//Question and all subtypes  *********************************************************
//import * as firebase from "firebase-admin"; //für die Node Admin Programme

import { Timestamp } from "@angular/fire/firestore" //für die App (neue API)

export enum QuestionState {
    Saved = 1,
    Submitted = 2,
    Deleted = 3, //eventell für den Admin gedacht.
    Accepted = 4, // wird am Ende der Reviewphase vom Server
    Rejected = 5  // gesetzt (manuell oder per Algorithmus)
}

export enum MessageType {
    Normal = 1,
    NewVersion = 2
}

export interface User {
    uid: string, //GUID
    nickname: string   //User Name
}

export interface Credidentials { //used to store credidentials in local storage
    eMail: string, //eMail
    pw: string   //PW
}

export interface Answer {
    text: string,
    correct: boolean
}

export interface Messages{
    lastMsgBy: string,
    messages: Message[],
    qid: string
}

export interface Message {
    date: string,
    user: User,
    text: string,
    type: MessageType
}

export interface Review {
    user: User,
    forVersion: number,
    wording: number,
    complexity: number,
    understandability: number,
    notCorrect: boolean,
    mustBeReported: boolean
    comment: string
}

export interface ReviewStatistic {
    countReviews: number,
    sumWording: number,
    avgWording: number,
    sumUnderstandability: number,
    avgUnderstandability: number,
    countComplexity1: number,
    countComplexity2: number,
    countComplexity3: number,
}

export interface Question {
    qid: string, //GUID
    mid: string, //Modul-ID Fremdschlüssel
    cid: string, //Course-ID Fremdschlüssel
    creator: User,
    version: number,
    topic: string, //aus Topc-Liste pro Modul
    questionText: string,
    answers: Answer[],
    state: QuestionState,
    remark: string,
    messages: Message[],
    reviews: Review[],
    countReviewsLatestVersion: number,
    created: any, //date set by server
    lastReview: any, //date set by server
    reviewStatistic: ReviewStatistic,
    bestReviewerId: string
}

export interface TestQuestion {
    qid: string, //GUID
    mid: string, //Modul-ID Fremdschlüssel
    cid: string, //Course-ID Fremdschlüssel
    creator: User,
    topic: string, //aus Topc-Liste pro Modul
    questionText: string,
    answers: Answer[],
    remark: string,
    points: number, // durchschnittliche Punkte aus understandability und 
    complexity: number
}

export interface Test {
    tid: string, // stored as CID+"-"+MID
    cid: string, // Course ID
    mid: string, //Modul-Id
    questions: TestQuestion[];
}

// Courses and moduls *********************************************************

export interface Modul {
    mid: string, //kann händisch vergeben werden, auch als 1,2,3...
    name: string,
    topics: string[],
    createFrom: string, // Zeit zum Erstellen und Reviewen 
    createTo: string,   // UTC-Date Format
    practiceFrom: string, // muss nach createFrom sein
    practiceTo: string // ab hier ist das Modul komplett geschlossen
}

export interface Points {
    PointsPerCreatedQuestion: number,
    PointsPerReview: number,
    PointsPerAcceptedQuestion: number,
    PointsPerStandardTrainingQuestion: number //20 Questions, unlimited time
    PointsPerAdvancedTrainingQuestion: number //20 Questions agains the clock
}

export interface Level {
    LID: number,
    LevelName: string,
    LevelColor: string,
    promotionAbove: number //Prozent
    demotionBelow: number //Prozent
    showHighScore: boolean //kann der User in diesem Level den Gesam- Highscore sehen?
}

export interface Course {
    cid: string, //GUID
    name: string, //Name of the Course, i.e. "ETWT 2020"
    CreateQuestionsPerModul: number, //z.B. max. 5 Fragen pro Modul
    CreateReviewsPerOwnQuestion: number, // z.B. pro erstellter Frage können 10 fremde reviet werden.
    searchDepthForQuestions: number,
    points: Points,
    participationKey: string, //all users who know the key may participate
    moduls: Modul[],
    identifierRegExp: string, //  Identifier des Users muss nach dieser RegExp gültig sein?
    validIdentifierMessage: string, //Meldung, wer berechtigt ist.
    colorYellowFromPoints: number,
    colorGreenFromPoints: number,
    highscoreActive: boolean,
    maxDailyTrainings: number,
    levels: Level[],
    levelCalculationDay: number, //1-7: 1=Monday - 7=Sunday
    levelCalulationTime: number //Format??? Minits since Midnight in UTC?
}

export interface AuthorizedUser {
    uid: string, //= ID des Logged in Users (Firebase Authentication)
    nickname: string, //Username
    identifier: string, //z.B. Matrikelnummer zur Identifikation
    lastCourse: string, //cid des zuletzt verwendeten Kurses
    preferedLanguage: string //de oder en
}

export interface UserCourse { // Collection-Key=<cid>-<uid>
    uid: string, //User-ID/FK
    cid: string, //Course-ID/FK
    points: number,
    level: number,
    days: number,
    lastDay: Timestamp, //UTC date of last active day (for days = streak)
    gold: number, //Währung
    countQuestions: number, // Anzahl der geschriebenen Questions
    countQuestionsAccepted: number, //wird bei Auswertung gesetzt - 30 Punkte
    countBestReviewer: number, //wird bei Auswertung gesetzt - 5 Punkte
    countReviews: number, //Anzahl der geschriebenen Reviews
    countStandardTrainings: number, //Anzahl der absolvierten Standard-Trainings
    countAdvancedTrainings: number, //Anzahl der absolvierten Advanced-Trainings
    settingShowInHighScore: boolean,
    settingUseTwoStepReviewSubmit: boolean,
    isLocked: boolean,
    dailyTrainingCounter: number,
    weekStartPoints: number,
    lastWeekPoints: number,
    lastWeekRank: number,
    lastWeekPromotion: number
}

export enum LogItemType {
    QuestionCreated = 1, //set cid, qid and mid
    QuestionReviewed = 2, //set cid, qid and mid
    QuestionAccepted = 3, //set cid, qid and mid
    BestReviewer = 4, //set cid, qid and mid
    StandardTraining = 5, //set tid - richtige Antworten werden gezeigt
    AdvancedTraining = 6, // es wird nur die Anzahl der richtigen Antworten geziegt
    ExpertTraining = 7, // nach Zeit
    Other = 8
}

export interface LogItem {
    uid: string, //mandatory
    cid: string, //mandatory
    mid: string, //bei Bedarf
    qid: string, //bei Bedarf
    tid: string, //Trainigs-ID
    type: LogItemType,
    logdate: string,
    info: any //additional type-specific info, maybe an extra object
}

//Interfaces for finding the best questions for tests
export interface ExtendedQuestion {
    qid: string, //Copy for Question.qid
    q: Question,
    reviews1: number,
    reviews2: number,
    reviewstotal: number,
    points: number,
    mustBeReported: number, //nur in der letzten Version
    notCorrect: number,
    complexity: number,
    topic: string
}

export interface QuestionBag {
    topic: string,
    complexity: number,
    questions: ExtendedQuestion[];
}

//Rewards for bestReviewer undangenommene Fragen
export interface RewardUser{
    uid: string, //the UID of the rewarded User
    bestReviewCount: number, //Anzahl dieser Rewards
    bestReviewPoints: number //dafür vergebene Punkte
    acceptedQestionCount: number, //Anzahl dieser Rewards
    acceptedQestiowPoints: number //dafür vergebene Punkte
}

export interface Reward {
    cid: string,
    mid: string,
    logDate: Timestamp, //automatisch vergeben
    awarded: boolean,
    awardedDate: Timestamp,
    rewardUsers: RewardUser[]
}

//Highscore
export interface HighScoreItem {
    uid: string, //GUID
    nickname: string,   //User Name
    points: number,
    level: number,
    weekPoints: number,
    showScore: boolean
}

export interface HighScore {
    cid: string,
    creationDate: Timestamp,
    items: HighScoreItem[],
    weekItems: HighScoreItem[],
    isFirstWeekScore: boolean
}

export interface ContentItem {
    header: string,
    text: string
}

export interface Content {
    contentid: string,
    name: string,
    language: string,
    items: ContentItem[]
}

export interface Config {
    MinVersion: string,
    ReleaseInfo: string,
    Version: string
}